import { useContext } from "react";
import { Button, Table, Tag } from "antd";
import {
    KeyOutlined,
    ReloadOutlined,
} from "@ant-design/icons";

import useAccessCode from "./useAccessCode";
import PageHeader from "../../components/PageHeader";
import ActiveFiltersBar from "../../components/ActiveFiltersBar";
import TableCard from "../../components/TableCard";
import TableDicaHint from "../../components/TableDicaHint";
import TablePagination from "../../components/TablePagination";
import { ThemeContext } from "../../contexts/ThemeContext";
import { poeValorComPontosEmMil } from "../../utils/Conversores";

export default function AccessCode() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const {
        isLoading,
        columns,
        tableData,
        stats,
        pagination,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        handleClickViewUser,
        reloadData,
    } = useAccessCode();

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <PageHeader
                icon={<KeyOutlined />}
                iconBg="linear-gradient(135deg, #13c2c2 0%, #08979c 100%)"
                title="Códigos de Autenticação"
                tag={<Tag color="cyan">{poeValorComPontosEmMil(stats.total)} códigos</Tag>}
                subtitle="Acompanhe em tempo real os códigos de validação e verificação de acesso (2FA) enviados aos cidadãos"
                actions={
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={reloadData}
                        loading={isLoading}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            fontWeight: 500,
                            height: 38,
                            borderRadius: 8,
                        }}
                    >
                        Atualizar
                    </Button>
                }
            />
            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique em qualquer linha ou utilize o botão de ação para visualizar os detalhes cadastrais do cidadão." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePaginationChange}
                itemName="códigos"
                pageSizeOptions={["10", "25", "50", "100"]}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    size="middle"
                    className={`modern-data-table ${isDark ? "modern-data-table-dark" : ""}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    onChange={handleTableChange}
                    scroll={{ x: 920 }}
                    onRow={(record) => ({
                        onClick: () => {
                            handleClickViewUser(record);
                        },
                        style: {
                            cursor: "pointer",
                        },
                    })}
                    locale={{
                        emptyText: "Nenhum código de autenticação encontrado.",
                    }}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePaginationChange}
                itemName="códigos"
                pageSizeOptions={["10", "25", "50", "100"]}
            />
        </div>
    );
}
